<app-navbar></app-navbar>

<br>

<div  style="background-color:#f5f5f5;width:99%;" class="mx-auto d-block">
    <div class="container-fluid" style="width:99%">
        <div class="row" > 
            <div class="col-md-2">

            </div>
            <div class="col-md-8"  >
                <mat-card>
                <div class="col-md-10 px-0 " >
                    <p class="aetnaMainDiv" class="break-msg" style="word-break: break-word;"> 
                        Your request has been successfully submitted. System will take 5–10 minutes to reflect subscription changes.
                       
                       <br> 
                    
                     
                    </p>
                  
                </div> 
            </mat-card>
            </div>
            <div class="col-md-2">

            </div>
        </div>
    </div>   
</div>



